import Home from './routes/Home.svelte';
import Contact from './routes/Contact.svelte';
import NotFound from './routes/NotFound.svelte';

export default {
    '/': Home,
    '/contact': Contact,
    // The catch-all route must always be last
    '*': NotFound
};
